"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _animejs = _interopRequireDefault(require("animejs"));
var _lodash = require("lodash");
var _boostLandingBg = _interopRequireDefault(require("../assets/boost/boost-landing-bg-1.webp"));
var _boostLandingBg2 = _interopRequireDefault(require("../assets/boost/boost-landing-bg-2.webp"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
/* eslint-disable jsx-a11y/click-events-have-key-events */

var BoostBannerImage = function BoostBannerImage(_ref) {
  var belowMd = _ref.belowMd;
  var animationRef = (0, _react.useRef)(null);
  (0, _react.useEffect)(function () {
    var handleScroll = (0, _lodash.debounce)(function () {
      var scrollPercentage = window.scrollY / (document.documentElement.scrollHeight - window.innerHeight) * 300;
      var newTop = "".concat(Math.max(-10, 10 - scrollPercentage), "%");
      (0, _animejs["default"])({
        targets: animationRef.current,
        top: newTop,
        duration: 250
      });
    }, 10);
    window.addEventListener("scroll", handleScroll);
    return function () {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "relative z-10",
    style: {
      maxWidth: belowMd ? 250 : 500
    }
  }, /*#__PURE__*/_react["default"].createElement("img", {
    alt: "",
    src: _boostLandingBg["default"]
  }), /*#__PURE__*/_react["default"].createElement("img", {
    alt: "",
    src: _boostLandingBg2["default"],
    className: "absolute top-0 z-20",
    style: {
      top: "10%"
    },
    ref: animationRef
  }));
};
var _default = exports["default"] = BoostBannerImage;